import React, { ReactNode } from "react";
import ReactDOM from "react-dom";
import { useOnClickOutside } from "usehooks-ts";
import { CloseOutlined } from "@ant-design/icons";

import { ModalToggle } from "~/hooks/useModal";
import styles from "./Modal.module.scss";

interface Props {
  isShow: boolean;
  toggle: ModalToggle;
  children?: ReactNode;
  isOutsideClick?: boolean; // Закрыть модальное окно при клике вне окна
  isShowCloseButton?: boolean; // Показать крестик в углу
}

export const Modal = ({
  isShow,
  toggle,
  isOutsideClick = false,
  isShowCloseButton = false,
  children
}: Props) => {
  const ref = React.useRef<HTMLInputElement>(null);

  const handleClickOutside = () => {
    if (!isOutsideClick) return;
    toggle();
  };

  useOnClickOutside(ref, handleClickOutside);

  return isShow
    ? ReactDOM.createPortal(
        <>
          <div className={styles.modalOverlay} />
          <div className={styles.modal} aria-modal aria-hidden tabIndex={-1} role="dialog">
            <div className={styles.container} ref={ref}>
              {isShowCloseButton && (
                <div className={styles.closeButton} onClick={toggle}>
                  <CloseOutlined />
                </div>
              )}
              {children}
            </div>
          </div>
        </>,
        document.body
      )
    : null;
};
